export const BLOCK_OPERATION_DAY_MODAL = 'BLOCK_OPERATION_DAY'
